<template>
    <div class="options">
        <button class="option" v-for="(option, index) in options" :key="index" @click="$emit('selected', option)">
            {{ option.label }}
        </button>
    </div>
</template>

<script>
export default {
    name: "qw-options",
    props: {
        options: {
            required: true,
            type: Array
        }
    }
}
</script>

<style lang="scss" scoped>
.options {
    overflow: hidden;
    width: 100%;
    border: 1px solid $primary;
    border-radius: 10px;
    .option {
        display: block;
        width: 100%;
        text-align: center;
        padding: 5px 0px;
        font-family: $lato;
        font-weight: normal;
        color: $primary;
        font-size: 14px;
        background: none;
        @include removeBootstrapOutline;
        border-bottom: 1px solid $primary!important;
        @include fastestTransition;
        &:last-child {
            border: none!important;
        }
        &:hover {
            background-color: $primary;
            color: $white;
        }
    }
}
</style>